var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.dataRows},scopedSlots:_vm._u([{key:"item.attributes",fn:function(ref){
var item = ref.item;
return [(item.attributes)?_c('ul',_vm._l((Object.keys(item.attributes)),function(attributeKey,index){return _c('li',{key:index},[_c('b',[_vm._v(_vm._s(attributeKey))]),_vm._v(": "+_vm._s(item.attributes[attributeKey])+" ")])}),0):_vm._e()]}},{key:"item.amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatWithCurrency(item.amount, _vm.order.currency_code))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }